import React, { useState, useEffect } from 'react';
import SearchableProviderTeamOfficeSelect from './SearchableProviderTeamOfficeSelect';

/**
 * AT packet: searchable provider + office (same pattern as Provider Team / referral PCP).
 * Stores provider id + site row id (payee_site_id ?? provider_site_id from search API).
 *
 * @param {string} [typeCode] - e.g. 'DR' (AT doctor), 'AT' (vendor). Omit for ongoing (all types).
 * @param {(row: object) => string} [formatOptionLabel] - passed to search dropdown (e.g. AT vendor = payee + type + office).
 */
function AtPacketProviderOfficeSelect({
  id,
  typeCode,
  formatOptionLabel,
  providerId,
  providerSiteId,
  onChange,
  disabled,
  required,
  emptyLabel = 'Click and type to search provider and office…',
  currentSelectionLabel = '',
  searchPlaceholder,
  resultHint,
}) {
  const [displayLabel, setDisplayLabel] = useState(() => (currentSelectionLabel || '').trim());

  useEffect(() => {
    setDisplayLabel((currentSelectionLabel || '').trim());
  }, [currentSelectionLabel]);

  const sid = providerSiteId != null && String(providerSiteId).trim() !== '' ? String(providerSiteId).trim() : '';
  const pid = providerId != null && String(providerId).trim() !== '' ? String(providerId).trim() : '';
  const value = sid !== '' ? sid : pid !== '' ? `provider:${pid}` : '';

  const handleOfficeChange = ({ value: v, label, providerId: pidFromRow }) => {
    if (v == null || String(v).trim() === '') {
      onChange({ providerId: '', providerSiteId: '' });
      setDisplayLabel('');
      return;
    }
    const vs = String(v).trim();
    if (vs.startsWith('provider:')) {
      onChange({ providerId: vs.slice('provider:'.length), providerSiteId: '' });
      setDisplayLabel((label || '').trim());
      return;
    }
    onChange({
      providerId: pidFromRow != null && String(pidFromRow).trim() !== '' ? String(pidFromRow).trim() : '',
      providerSiteId: vs,
    });
    setDisplayLabel((label || '').trim());
  };

  const defaultHint = typeCode
    ? `Search by name or type — ${typeCode} offices only, up to 25 shown.`
    : 'Search by name or type — up to 25 offices (any provider type).';

  return (
    <div className="at-packet-provider-office-wrap">
      <SearchableProviderTeamOfficeSelect
        id={id}
        typeCode={typeCode}
        formatOptionLabel={formatOptionLabel}
        value={value}
        displayLabel={displayLabel}
        onChange={handleOfficeChange}
        disabled={disabled}
        required={required}
        placeholder={emptyLabel}
        searchPlaceholder={searchPlaceholder || 'Last name, first name, or type code…'}
        resultHint={resultHint || defaultHint}
        hiddenInputName={`${id}_site`}
        className="at-packet-provider-office-search"
      />
    </div>
  );
}

export default AtPacketProviderOfficeSelect;
